import commonMapping from "@/mapping/common";

export const enableStringTable = {
  Enable_GUIStringTable: commonMapping.intToBoolean,
};

export default enableStringTable;
